import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class RoomRepositoryService extends BaseRepositoryService<
  ModelRegistry['room']
> {
  recordName = 'room';
  implementMethods = ['query', 'createRecord', 'unloadAll'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/room': RoomRepositoryService;
  }
}
